import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";
import SleepyNewsAnchor from "../../components/SleepyNewsAnchor";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—February 2009" />
	<Old2005BlogPage>
		<h2>February 2009</h2>



		<h3 className="blogdate">
		Saturday, February 28, 2009
		</h3>






		<h4 className="blogitemtitle">
			<SleepyNewsAnchor num="1">Cheesy wake-up</SleepyNewsAnchor>
		</h4>





		   <div className="blogitembody">
				<p>
				I am not kidding - the very first cohesive thought I had this morning, in my groggy awakening state,
				was the following revised chorus for the song <span style={{fontStyle: "italic"}}>Blinded by the Light</span>:
				</p>
				<ul><li>
					I was rinded by the white; wrapped up like a Brie, another Camembert delight
				</li></ul>
				<p></p>
				<p>
				How ridiculous!
				I believe that the word rind is normally a noun.
				The only verbal definition I found on dictionary.com was "to remove the rind".
				Yet this morning I brilliantly created a new verbal meaning: "to be enclosed in a rind".
				</p><p>
				Go ahead.
				Say it.
				It's not the first time I've said something a bit cheesy.
				</p>
		   </div>
		   <div className="blogitemfooter">
		   posted by Jesse @ 9:28 AM &nbsp;
		   </div>






		<h3 className="blogdate">
		Thursday, February 26, 2009
		</h3>






		<h4 className="blogitemtitle">
		Out for a drink
		</h4>





		   <div className="blogitembody">
		   Infer whatever you fancy from this tidbit...<br /><br />Last night was not surprising - it seemed familiar, really.  It felt like a summarizing, if not typical, "evening out in Wellington" for me.  I arrived at Bodega a bit early (music advertised for 9:00, but no one really shows up till 10:30 when the music actually starts) and sat alone with my pint for a long session of people watching.  It was a young crowd and I was wearing my "<span className="blsp-spelling-error" id="SPELLING_ERROR_0">IPood</span>" tee-shirt, which garnered a bit of giggling and gazing, and the odd boyish comment.  I was out to see a friend's band perform during university orientation week.<br /><br />A jolly roundish girl advanced across the room towards me - she wanted a photo of her and I with my shirt.  We posed and her friend captured the moment.  I responded to her inquisitions; "No, when I chose this shirt, I wasn't thinking it would pick up all the girls."  I was soon back to my beer.<br /><br />At last, the music started.  A tall Kiwi guy bopping beside me felt the urge to tell me, "You're looking really good tonight!"  Thanks and a smile, and I bopped and dodged a little distance away from him.  <span className="blsp-spelling-error" id="SPELLING_ERROR_1">Neve</span> and Deeps found me and we "danced it up" a bit - <span className="blsp-spelling-error" id="SPELLING_ERROR_2">Neve</span> from Italy, Deeps from New York.  We became the Three Dancing Foreigners for the remainder of the first band's set.<br /><br />During the band changing break I was approached by my new jolly acquaintance.  Turns out she's from New York, too.  We had a quick chat until I lost interest and she <span className="blsp-spelling-error" id="SPELLING_ERROR_3"></span>left to find her friends.<br /><br />Ah, my friend's band started.  A cute, smallish, Kiwi girl danced beside and in front of me for most of the set, which I found intriguing as there was more than sufficient surrounding space to warrant such proximity.  In between songs I became friendly and asked her name.  She looked at me with cinched lips and then decided to look away from me.  I laughed and said, "It's just a name," to which she made ignoring efforts.  So we kept dancing while I chuckled.<br /><br />The attractive Kiwi girl against the wall with the table-cloth shirt made brief, smiling eye-contact with me several times, giggling with her friend each time afterwards.  I regarded her as a mirage oasis; a trickle of roaming stags were drawn to her visibly fresh, watery surface, yet they all soon wandered disappointingly onwards in further pursuit of a guzzle.  I chose to not adventure forward to determine if there actually was refreshing water at that location.<br /><br />-- Back to http://www.jesserivest.com/
		   </div>
		   <div className="blogitemfooter">
		   posted by Jesse @ 2:12 PM &nbsp;
		   </div>






		<h3 className="blogdate">
		Friday, February 13, 2009
		</h3>






		<h4 className="blogitemtitle">
		The years, their getting on
		</h4>





		   <div className="blogitembody">
		   Countless times over the past few years I've read my own written words and found that I've used the wrong <em>there</em>. I just read my note from a few days ago, "She said <em>their</em> probably wouldn't be enough..." and the word <em>their</em> made me cringe with dismay.<br /><br />These wrong <em>there</em>s pop up for me instantly - and quite regularly - so it's clear that I am quick to know the difference between <em>there</em>, <em>their</em>, and <em>they're</em>. However, I'm obviously quick to use the wrong word, unconsciously, when I'm writing fast! I guess I'm getting old? Or perhaps I had a difficult time differentiating these words when I was younger? I can't remember it being a problem...
		   </div>
		   <div className="blogitemfooter">
		   posted by Jesse @ 2:48 PM &nbsp;
		   </div>




		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
